import { Resource, ResourcesState } from "entities/hallmap/model/types";
import { FC, useEffect, useMemo, useState } from "react";
import { resourceDopType } from "widgets/mobileIndex/lib/hooks/useMobilePlace";
import { Circle, Name, Order, Time } from "./style";
import { ExitIconButton } from "shared/ui/buttons/iconButtons/exitButton";
import { useOrderInfo } from "entities/orders";
import { DANGER_COLOR } from "shared/consts";

type SittingOrderProps = {
  order: Partial<Resource & ResourcesState & resourceDopType>;
  onEndVisitClick: (id: number) => void;
  isLoading: boolean;
}

export const SittingOrder: FC<SittingOrderProps> = ({
  order,
  onEndVisitClick,
  isLoading,
}) => {

  const [ startString, setStartString ] = useState<string>('');
  const [ endString, setEndString ] = useState<string>('');

  const { open, setSelectedId } = useOrderInfo();

  useEffect(() => {
    if (!order?.order?.dt_start||!order?.order?.dt_end) return;
    
    const startDate = new Date(order?.order?.dt_start)
    const endDate = new Date(order?.order?.dt_end)

    const startHours = startDate.getHours() > 9 ? startDate.getHours() : `0${startDate.getHours()}`
    const startMinutes = startDate.getMinutes() > 9 ? startDate.getMinutes() : `0${startDate.getMinutes()}`
    const endHours = endDate.getHours() > 9 ? endDate.getHours() : `0${endDate.getHours()}`
    const endMinutes = endDate.getMinutes() > 9 ? endDate.getMinutes() : `0${endDate.getMinutes()}`

    setStartString(`${startHours}:${startMinutes}`)
    setEndString(`${endHours}:${endMinutes}`)

  }, [order?.order?.dt_start, order?.order?.dt_end])

  const onClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    if (order?.order?.id) {
      onEndVisitClick(order.order.id)
    }
  }

  const onOrderClick = async () => {
    if (order?.order?.id) {
      setSelectedId(order?.order?.id);
      open();
    }
  }

  const circleBg = useMemo(() => {
    if (order.state === 'ending' || order.state === 'exceeding') {
      return DANGER_COLOR
    }
    return undefined
  },[order])
  return (
    <Order className={isLoading ? '_skeleton' : ''} onClick={onOrderClick}>
      <Circle $bgc={circleBg}>{order.name}</Circle>
      <Name>{order?.order?.person?.name}</Name>
      <Time>{startString} - {endString}</Time>
      {order?.order?.id && 
      <ExitIconButton 
        onClick={onClick}
        styles={{
          margin: '-8px -12px -8px 0',
          height: '56px',
          width: '56px',
        }}
      />
      }
    </Order>
  )
}